import { axios } from 'libs';

const resource = '/usuarios';

export const getUserData = () => {
  return axios.get(`${resource}/me`);
};

export const getUserPermissions = () => {
  return axios.get(`${resource}/permissoes`);
};
